// 'LABEL_START_NW_CONV' : 'START A NEW CONVERSATION',
export const en = {
    'LABEL_PLACEHOLDER': 'type your message..',
    'LABEL_START_NW_CONV': 'New conversation',
    'LABEL_FIRST_MSG': 'Describe shortly your problem, you will be contacted by an agent.',
    // tslint:disable-next-line:max-line-length
    'LABEL_FIRST_MSG_NO_AGENTS': '🤔 All operators are offline at the moment. You can anyway describe your problem. It will be assigned to the support team who will answer you as soon as possible.',
    'LABEL_SELECT_TOPIC': 'Select a topic',
    'LABEL_COMPLETE_FORM': 'Complete the form to start a conversation with the next available agent.',
    'LABEL_FIELD_NAME': 'Name',
    'LABEL_ERROR_FIELD_NAME': 'Required field (minimum 5 characters).',
    'LABEL_FIELD_EMAIL': 'Email',
    'LABEL_ERROR_FIELD_EMAIL': 'Enter a valid email address.',
    'LABEL_WRITING': 'is writing...',
    'AGENT_NOT_AVAILABLE': ' Offline',
    'AGENT_AVAILABLE': ' Online',
    'GUEST_LABEL': 'Guest',
    'ALL_AGENTS_OFFLINE_LABEL': 'All operators are offline at the moment',
    'LABEL_LOADING': 'Loading...',
    'CALLOUT_TITLE_PLACEHOLDER': 'Need Help?',
    'CALLOUT_MSG_PLACEHOLDER': 'Click here and start chatting with us!',
    'CUSTOMER_SATISFACTION': 'Customer satisfaction',
    'YOUR_OPINION_ON_OUR_CUSTOMER_SERVICE': 'your opinion on our customer service',
    'DOWNLOAD_TRANSCRIPT': 'Download transcript',
    'BACK': 'Back',
    'YOUR_RATING': 'your rating',
    'WRITE_YOUR_OPINION': 'Write your opinion ... (optional)',
    'SUBMIT': 'Submit',
    'THANK_YOU_FOR_YOUR_EVALUATION': 'Thank you for your evaluation',
    'YOUR_RATING_HAS_BEEN_RECEIVED' : 'your rating has been received',

    'ALERT_LEAVE_CHAT': 'Do you want to leave the chat?',
    'YES': 'Yes',
    'NO': 'No',
    'BUTTON_CLOSE_TO_ICON': 'Minimize chat',
    'BUTTON_EDIT_PROFILE': 'Update profile',
    'BUTTON_DOWNLOAD_TRANSCRIPT': 'Download transcript',
    'RATE_CHAT': 'Rate chat',
    'WELLCOME_TITLE': 'Hi, wellcome to AXEL',
    'WELLCOME_MSG': 'How can we help?',
    'WELLCOME': 'Wellcome',
    'OPTIONS': 'options',

    'SOUND_OFF': 'sound off',
    'SOUND_ON': 'sound on',
    'LOGOUT': 'logout',
    'CLOSE': 'close',
    'PREV_CONVERSATIONS': 'Your conversations',
    'YOU': 'You',
    'SHOW_ALL_CONV': 'show all',
    'START_A_CONVERSATION': 'Start a conversation',
    'NO_CONVERSATION': 'No conversation',
    'SEE_PREVIOUS': 'see previous',
    'WAITING_TIME_FOUND': 'The team typically replies in ',
    'WAITING_TIME_NOT_FOUND': 'Will reply as soon as they can'
};

// 'LABEL_START_NW_CONV': 'INIZIA UNA NUOVA CONVERSAZIONE',
export const it = {
    'LABEL_PLACEHOLDER': 'Scrivi la tua domanda...',
    'LABEL_START_NW_CONV': 'Nuova conversazione',
    'LABEL_FIRST_MSG': 'Descrivi sinteticamente il tuo problema, ti metteremo in contatto con un operatore specializzato.',
    // tslint:disable-next-line:max-line-length
    'LABEL_FIRST_MSG_NO_AGENTS': '🤔 Tutti gli operatori sono offline al momento.Puoi comunque descrivere il tuo problema. Sarà assegnato al team di supporto che ti risponderà appena possibile.',
    'LABEL_SELECT_TOPIC': 'Seleziona un argomento',
    'LABEL_COMPLETE_FORM': 'Completa il form per iniziare una conversazione con il prossimo agente disponibile.',
    'LABEL_FIELD_NAME': 'Nome',
    'LABEL_ERROR_FIELD_NAME': 'Nome richiesto (minimo 2 caratteri).',
    'LABEL_FIELD_EMAIL': 'Email',
    'LABEL_ERROR_FIELD_EMAIL': 'Inserisci un indirizzo email valido.',
    'LABEL_WRITING': 'sta scrivendo...',
    'AGENT_NOT_AVAILABLE': ' Offline',
    'AGENT_AVAILABLE': ' Online',
    'GUEST_LABEL': 'Ospite',
    'ALL_AGENTS_OFFLINE_LABEL': 'Tutti gli operatori sono offline al momento',
    'LABEL_LOADING': 'Caricamento...',
    'CALLOUT_TITLE_PLACEHOLDER': 'Bisogno di aiuto?',
    'CALLOUT_MSG_PLACEHOLDER': 'Clicca qui e inizia a chattare con noi!',
    'CUSTOMER_SATISFACTION': 'Valutazione servizio',
    'YOUR_OPINION_ON_OUR_CUSTOMER_SERVICE': 'il tuo giudizio sul nostro servizio clienti',
    'DOWNLOAD_TRANSCRIPT': 'Scarica transcript',
    'BACK': 'Indietro',
    'YOUR_RATING': 'il tuo voto',
    'WRITE_YOUR_OPINION': 'Scrivi la tua opinione...(opzionale)',
    'SUBMIT': 'Invia',
    'THANK_YOU_FOR_YOUR_EVALUATION': 'Grazie per la tua valutazione',
    'YOUR_RATING_HAS_BEEN_RECEIVED' : 'il tuo voto è stato ricevuto',

    'ALERT_LEAVE_CHAT': 'Vuoi abbandonare la conversazione?',
    'YES': 'Yes',
    'NO': 'No',
    'BUTTON_CLOSE_TO_ICON': 'Riduci a icona la chat',
    'BUTTON_EDIT_PROFILE': 'Modifica profilo',
    'BUTTON_DOWNLOAD_TRANSCRIPT': 'Scarica transcript',
    'RATE_CHAT': 'Valuta chat',
    'WELLCOME_TITLE': 'Ciao, benvenuto su AXEL',
    'WELLCOME_MSG': 'Come possiamo aiutarti?',
    'OPTIONS': 'opzioni',
    'WELLCOME': 'Benvenuto',

    'SOUND_OFF': 'suono spento',
    'SOUND_ON': 'suono acceso',
    'LOGOUT': 'disconnetti',
    'CLOSE': 'Chiudi',
    'PREV_CONVERSATIONS': 'Le tue conversazioni',
    'YOU': 'YOU',
    'SHOW_ALL_CONV': 'vedi tutte',
    'START_A_CONVERSATION': 'Inizia una conversazione',
    'NO_CONVERSATION': 'Nessuna conversazione attiva',
    'SEE_PREVIOUS': 'vedi precedenti',
    'WAITING_TIME_FOUND': 'Il team tipicamente risponde in ',
    'WAITING_TIME_NOT_FOUND': 'Vi risponderemo appena possibile'
};

export const ru = {
    'LABEL_PLACEHOLDER': 'Введите ваше сообщение..',
    'LABEL_START_NW_CONV': 'Новое обращение',
    'LABEL_FIRST_MSG': 'Кратко опишите вашу проблему, наш агент поможет вам.',
    // tslint:disable-next-line:max-line-length
    'LABEL_FIRST_MSG_NO_AGENTS': '🤔 Все операторы заняты в данный момент. Опишите вашу проблему. мы назначим вам ближайшего агент поддержки когда он освободиться.',
    'LABEL_SELECT_TOPIC': 'Выбрать тему',
    'LABEL_COMPLETE_FORM': 'Заполните форму, чтобы начать разговор со следующим доступным агентом.',
    'LABEL_FIELD_NAME': 'Имя',
    'LABEL_ERROR_FIELD_NAME': 'Обязательное поле (минимум 5 символов)',
    'LABEL_FIELD_EMAIL': 'Email',
    'LABEL_ERROR_FIELD_EMAIL': 'Введите корректный электронный адрес.',
    'LABEL_WRITING': 'печатает...',
    'AGENT_NOT_AVAILABLE': ' Не в сети',
    'AGENT_AVAILABLE': ' В сети',
    'GUEST_LABEL': 'Гость',
    'ALL_AGENTS_OFFLINE_LABEL': 'Все операторы на данный момент не работают',
    'LABEL_LOADING': 'Загрузка...',
    'CALLOUT_TITLE_PLACEHOLDER': 'Нужна помощь?',
    'CALLOUT_MSG_PLACEHOLDER': 'Нажмите здесь и начните общаться с нами!',
    'CUSTOMER_SATISFACTION': 'Удовлетворенность клиентов',
    'YOUR_OPINION_ON_OUR_CUSTOMER_SERVICE': 'Ваше мнение о нашей службе поддержки',
    'DOWNLOAD_TRANSCRIPT': 'Скачать стенограмму',
    'BACK': 'Назад',
    'YOUR_RATING': 'ваш рейтинг',
    'WRITE_YOUR_OPINION': 'Напишите свое мнение ... (необязательно)',
    'SUBMIT': 'Submit',
    'THANK_YOU_FOR_YOUR_EVALUATION': 'Спасибо за вашу оценку',
    'YOUR_RATING_HAS_BEEN_RECEIVED' : 'Ваша оценка была получена',

    'ALERT_LEAVE_CHAT': 'Вы хотите выйти из чата?',
    'YES': 'Да',
    'NO': 'Нет',
    'BUTTON_CLOSE_TO_ICON': 'Свернуть чат',
    'BUTTON_EDIT_PROFILE': 'Обновить профиль',
    'BUTTON_DOWNLOAD_TRANSCRIPT': 'Скачать стенограмму',
    'RATE_CHAT': 'Оценить чат',
    'WELLCOME_TITLE': 'Привет, добро пожаловать в AXEL Support',
    'WELLCOME_MSG': 'Как мы можем помочь?',
    'WELLCOME': 'Добро пожаловать',
    'OPTIONS': 'опции',

    'SOUND_OFF': 'звук выкл',
    'SOUND_ON': 'звук вкл',
    'LOGOUT': 'выход',
    'CLOSE': 'закрыть',
    'PREV_CONVERSATIONS': 'Ваши беседы',
    'YOU': 'ВЫ',
    'SHOW_ALL_CONV': 'показать все',
    'START_A_CONVERSATION': 'Начать беседу',
    'NO_CONVERSATION': 'Нет обращений',
    'SEE_PREVIOUS': 'смотри предыдущий',
    'WAITING_TIME_FOUND': 'Команда обычно отвечает в',
    'WAITING_TIME_NOT_FOUND': 'Ответим как можно скорее'
};

export const ka = {
    'LABEL_PLACEHOLDER': 'შეიყვანეთ თქვენი შეტყობინება..',
    'LABEL_START_NW_CONV': 'ახალი მიმართვა',
    'LABEL_FIRST_MSG': 'მოკლედ თქვენი პრობლემა, და ჩვენი აგენტი დაგეხმარებათ.',
    // tslint:disable-next-line:max-line-length
    'LABEL_FIRST_MSG_NO_AGENTS': '🤔 ყველა ოპერატორები დაკავებული მომენტში. გთხოვთ აღწეროთ თქვენი პრობლემა. ჩვენ მივანიჭოთ თქვენ უახლოეს მხარდაჭერა აგენტი, როდესაც ეს არ არის შესაძლებელი.',
    'LABEL_SELECT_TOPIC': 'თემის არჩევა',
    'LABEL_COMPLETE_FORM': 'შეავსეთ ფორმა დაიწყოს საუბარი შემდეგი ხელმისაწვდომი აგენტი.',
    'LABEL_FIELD_NAME': 'სახელი',
    'LABEL_ERROR_FIELD_NAME': 'საჭირო ველი (მინიმუმ 5 სიმბოლო)',
    'LABEL_FIELD_EMAIL': 'ელ. ფოსტა',
    'LABEL_ERROR_FIELD_EMAIL': 'შეიყვანეთ სწორი ელექტრონული ფოსტის მისამართი.',
    'LABEL_WRITING': 'ბეჭდავს...',
    'AGENT_NOT_AVAILABLE': ' არ თამაშობს',
    'AGENT_AVAILABLE': 'ქსელში',
    'GUEST_LABEL': 'სასტუმრო',
    'ALL_AGENTS_OFFLINE_LABEL': 'ყველა ოპერატორი ამჟამად არ მუშაობს',
    'LABEL_LOADING': 'იტვირთება...',
    'CALLOUT_TITLE_PLACEHOLDER': 'დახმარება გჭირდებათ?',
    'CALLOUT_MSG_PLACEHOLDER': 'დააწკაპუნეთ აქ და დავიწყოთ ჩვენთან!',
    'CUSTOMER_SATISFACTION': 'მომხმარებელთა კმაყოფილება',
    'YOUR_OPINION_ON_OUR_CUSTOMER_SERVICE': 'თქვენი აზრი ჩვენი მხარდაჭერის სამსახურის შესახებ',
    'DOWNLOAD_TRANSCRIPT': 'ჩამოტვირთეთ ტრანსკრიპტი',
    'BACK': 'უკან',
    'YOUR_RATING': 'თქვენი რეიტინგი',
    'WRITE_YOUR_OPINION': 'დაწერეთ თქვენი აზრი ... (სურვილისამებრ)',
    'SUBMIT': 'გაგზავნა',
    'THANK_YOU_FOR_YOUR_EVALUATION': 'გმადლობთ, თქვენი შეფასება',
    'YOUR_RATING_HAS_BEEN_RECEIVED' : 'შენი რეიტინგი მიიღო',

    'ALERT_LEAVE_CHAT': 'გსურთ გამოხვიდეთ სტატისტიკა?',
    'YES': 'დიახ',
    'NO': 'არა',
    'BUTTON_CLOSE_TO_ICON': 'დაიშალოს სტატისტიკა',
    'BUTTON_EDIT_PROFILE': 'განაახლეთ თქვენი პროფილი',
    'BUTTON_DOWNLOAD_TRANSCRIPT': 'ჩამოტვირთეთ ტრანსკრიპტი',
    'RATE_CHAT': 'შეაფასოს სტატისტიკა',
    'WELLCOME_TITLE': 'გამარჯობა, კეთილი იყოს თქვენი მობრძანება AXEL მხარდაჭერა',
    'WELLCOME_MSG': 'როგორ შეგვიძლია დავეხმაროთ?',
    'WELLCOME': 'მოგესალმებით',
    'OPTIONS': 'პარამეტრები',

    'SOUND_OFF': 'ხმის გამორთვა',
    'SOUND_ON': 'ხმის',
    'LOGOUT': 'გასვლა',
    'CLOSE': 'დახურვა',
    'PREV_CONVERSATIONS': 'თქვენი საუბარი',
    'YOU': 'თქვენ',
    'SHOW_ALL_CONV': 'აჩვენეთ ყველა',
    'START_A_CONVERSATION': 'დაწყება საუბარი',
    'NO_CONVERSATION': 'მიმართვა',
    'SEE_PREVIOUS': 'იხილეთ წინა',
    'WAITING_TIME_FOUND': 'გუნდი ჩვეულებრივ პასუხობს',
    'WAITING_TIME_NOT_FOUND': 'გიპასუხებთ რაც შეიცლება'
};


// WEBPACK FOOTER //
// ./src/app/utils/translations.ts